konnyScript(function($){
  /*
    if($('#knKO70wrap .rvCon').length > 0){
      setTimeout(function() { 
        var rvslide_text_height = [];
        $('#knKO70wrap .rvCon').each(function(){
          rvslide_text_height.push($(this).height());
        })
    
        var rvslide_max_height = Math.max(...rvslide_text_height);
        $('#knKO70wrap .rvCon').height(rvslide_max_height);
      }, 1000);
    }
  */
    $('#apdTap .size').click(function(){
      $(this).toggleClass('on');
    })
  
    
    var swiper = new Swiper("#knKO70rv_swiper_slide1", {
        slidesPerView: 4,
        slidesPerGroup: 1,
        spaceBetween: 15,
        loop: false,
        autoHeight: false,
        scrollbar: {
            el: '#knKO70rv_swiper_slide1 .swiper-scrollbar',
        },
        pagination: {
            el: '#knKO70rv_swiper_slide1 .swiper-pagination',
        },
        navigation: {
            nextEl: '#knKO70rv_swiper_slide1 .swiper-button-next',
            prevEl: '#knKO70rv_swiper_slide1 .swiper-button-prev',
        },
    });
    
    var swiper = new Swiper("#knKO70rv_swiper_slide2", {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 10,
        loop: false,
        scrollbar: {
            el: '#knKO70rv_swiper_slide2 .swiper-scrollbar',
        },
        pagination: {
            el: '#knKO70rv_swiper_slide2 .swiper-pagination',
        },
        navigation: {
            nextEl: '#knKO70rv_swiper_slide2 .swiper-button-next',
            prevEl: '#knKO70rv_swiper_slide2 .swiper-button-prev',
        },
    });

});